export default __webpack_public_path__ + "static/media/jumbo.803413c8.png";